export default {
  title: 'Angebot umbenennen',
  subtitle: 'Geben Sie einen neuen Namen für Ihr Angebot ein (maximal 40 Zeichen)',
  toasts: {
    success: 'Angebot erfolgreich umbenannt',
    error: 'Fehler beim Umbenennen des Angebots',
  },
  buttons: {
    rename: 'Umbenennen',
  },
  form: {
    title: {
      label: 'Angebotsname',
      placeholder: 'Angebotsname eingeben',
    },
  },
};
